import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { HelpCircle, Scale } from 'lucide-react'; // Added Scale icon for legal feel
// import { Get_Api } from "../API_URL"; // Commented out
// import { toast } from "react-toastify"; // Commented out

function TermsConditions() {
  /* --- API Logic Commented Out ---
  const [termsconditions, settermsconditions] = useState(null);
  const [Isloading, setIsloading] = useState(false);

  const Gettermsconditions = async () => {
    try {
      setIsloading(true);
      const response = await Get_Api(`api/admin/GetTermsandcondition`);
      settermsconditions(response?.data?.Termsandcondition);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toast.error(error?.response?.message || "Failed to fetch data");
      console.error("Error fetching terms:", error);
    }
  };

  useEffect(() => {
    Gettermsconditions();
  }, []);
  ----------------------------------- */

  // Static Content Data
  const termsData = [
    {
      title: "1. Use of Website",
      desc: "This website and its content are intended solely for informational purposes. You agree not to misuse, copy, or exploit any part of our website for unlawful activities."
    },
    {
      title: "2. Intellectual Property",
      desc: "All content, logos, images, and materials on this website are the property of Mobikode unless otherwise stated. Unauthorized use, reproduction, or distribution may result in legal action."
    },
    {
      title: "3. Limitation of Liability",
      desc: "Mobikode will not be held liable for any direct, indirect, or incidental damages resulting from the use of our website or services. We do not guarantee that the site will be error-free or uninterrupted."
    },
    {
      title: "4. User Responsibilities",
      desc: (
        <ul className="space-y-3">
          <li>You agree to use our services responsibly and not engage in harmful activities.</li>
          <li>Providing false information or impersonating others is strictly prohibited.</li>
          <li>You are responsible for maintaining the confidentiality of any account credentials.</li>
        </ul>
      )
    },
    {
      title: "5. Governing Law",
      desc: "These Terms shall be governed by and interpreted in accordance with the laws of India. Any disputes arising shall be subject to the exclusive jurisdiction of the courts in India."
    }
  ];

  return (
    <>
<Helmet>
    <title>
        Terms & Conditions | Website Usage & Policies | Mobikode
    </title>

    <meta
        name="description"
        content="Read Mobikode's Terms & Conditions covering website usage, intellectual property, user responsibilities, limitation of liability, governing law, and other important service policies."
    />

    <meta
        name="keywords"
        content="Mobikode Terms and Conditions, Terms and Conditions Mobikode, Mobikode Terms of Use, Website Terms and Conditions, Website Usage Policy, IT Services Terms, Software Services Terms, User Responsibilities, Intellectual Property Policy, Limitation of Liability, Governing Law, Mobikode Legal Policy"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/terms-conditions"
    />

    <meta
        property="og:title"
        content="Terms & Conditions | Website Usage & Policies | Mobikode"
    />

    <meta
        property="og:description"
        content="Review Mobikode's Terms & Conditions for website usage, intellectual property, user responsibilities, liability limitations, and applicable governing laws."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/terms-conditions"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/img4.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Terms & Conditions | Website Usage & Policies | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Understand Mobikode's website terms, user responsibilities, intellectual property guidelines, liability limitations, and governing law."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/img4.png"
    />
</Helmet>

      <div className="min-h-screen bg-white text-[#0E2A62]">

        {/* --- Hero Section --- */}
        <section className="relative w-full h-[450px] lg:h-[550px] flex items-center bg-[#000814] overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="/assets/what/img4.png"
              alt="Legal Background"
              className="w-full h-full object-cover opacity-80"
            />
            <div style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }} className="absolute inset-0 "></div>
          </div>

          <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

            <h1 className="text-white font-[600] text-4xl md:text-[55px] font-sora leading-[1.1] mb-4">
              Terms & Conditions
            </h1>
            <p className="text-gray-300 text-base md:text-lg font-graphik font-light max-w-[700px]">
              Please read these terms carefully. By using our platform, you agree to the following guidelines.
            </p>
          </div>
        </section>

        {/* --- Static Content Section --- */}
        <section className="py-12 lg:py-20 bg-white">
          <div className="max-w-[1000px] mx-auto px-[20px]">

            <p className="text-[#49577A] lg:text-[16px] text-[14px] font-[500] font-graphik mb-12 leading-relaxed border-l-4 border-[#0E2A62] pl-6 text-justify">
              Welcome to Mobikode! By accessing and using our website, you agree to comply with and be bound by the following Terms & Conditions. If you do not agree, please do not use our services.
            </p>

            <div className="space-y-10">
              {termsData.map((item, index) => (
                <div key={index} className="border-b border-gray-100 pb-8 last:border-0">
                  <h2 className="text-[16px] md:text-[20px] font-sora font-[600] text-[#0E2A62] mb-4">
                    {item.title}
                  </h2>
                  <div className="text-[#49577A] lg:text-[16px] text-[14px] font-[500] font-graphik leading-relaxed text-justify">
                    {item.desc}
                  </div>
                </div>
              ))}
            </div>

            {/* --- Help/Contact Card --- */}
            <div className="mt-16 p-6 md:p-10 bg-[#0E2A62] text-white flex flex-col md:flex-row items-center gap-6 shadow-xl">
              <div className="bg-white/10 p-3 rounded-xl">
                <HelpCircle className="text-white" size={32} />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h4 className="text-[16px] lg:text-[20px] font-sora font-[600] mb-1">Have Questions?</h4>
                <p className="text-white/80 font-graphik text-[14px] md:text-[16px] font-[500]">Our legal team is here to help you understand our policies at <strong>support@mobikode.com</strong></p>
              </div>
              <a
                href="mailto:support@mobikode.com"
                className="whitespace-nowrap bg-white text-[#0E2A62] px-8 py-3 rounded-full font-[500] hover:bg-gray-100 transition-all text-[14px] lg:text-[16px] font-graphik"
              >
                Contact Legal
              </a>
            </div>

          </div>
        </section>

        {/* <style dangerouslySetInnerHTML={{
          __html: `
          ul li {
            position: relative;
            padding-left: 25px;
          }
          ul li::before {
            color: #0E2A62; 
            font-weight: bold;
            position: absolute;
            left: 0;
            font-size: 18px;
          }
        `}} /> */}
      </div>
    </>
  );
}

export default TermsConditions;